import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	updateButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentSelectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentSelectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	childSelectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	childSelectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidOptionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updateButtonText: {
		id: 'jql-builder-basic-cascading-select.update-button-text',
		defaultMessage: 'Update',
		description:
			'Action to update the issue search criteria with the selected field options included',
	},
	parentSelectLabel: {
		id: 'jql-builder-basic-cascading-select.parent-select-label',
		defaultMessage: 'Parent option',
		description: 'label that appears for the parent option dropdown',
	},
	parentSelectPlaceholder: {
		id: 'jql-builder-basic-cascading-select.parent-select-placeholder',
		defaultMessage: 'Select parent option',
		description: 'placeholder text for dropdown containing parent options to choose from',
	},
	childSelectLabel: {
		id: 'jql-builder-basic-cascading-select.child-select-label',
		defaultMessage: 'Child option',
		description: 'label that appears for the child option dropdown',
	},
	childSelectPlaceholder: {
		id: 'jql-builder-basic-cascading-select.child-select-placeholder',
		defaultMessage: 'Select child option',
		description: 'placeholder text for dropdown containing child options to choose from',
	},
	noOptions: {
		id: 'jql-builder-basic-cascading-select.no-options',
		defaultMessage: 'No options available',
		description: 'appears in the dropdown when there are no options to choose from',
	},
	invalidOptionMessage: {
		id: 'jql-builder-basic-cascading-select.invalid-option-message',
		defaultMessage: '"{selectField}" selection is not valid for the current project.',
		description:
			'The text displayed as an error message under the select dropdown when the selected option is not available in the current search context. The "selectField" field will be either the parentSelectLabel or childSelectLabel message to indicate which field it is for.',
	},
});
export default messages;
